'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _hammerjs = require('hammerjs');

var _hammerjs2 = _interopRequireDefault(_hammerjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Controller = function (_Component) {
  _inherits(Controller, _Component);

  function Controller(props) {
    _classCallCheck(this, Controller);

    var _this = _possibleConstructorReturn(this, (Controller.__proto__ || Object.getPrototypeOf(Controller)).call(this, props));

    _this.state = {
      slideIndex: props.defaultSlideIndex - 1 || 0,
      slideLength: 0
    };
    _this.onClick = _this.onClick.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onNextSlide = _this.onNextSlide.bind(_this);
    _this.onPrevSlide = _this.onPrevSlide.bind(_this);
    return _this;
  }

  _createClass(Controller, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        slideIndex: this.state.slideIndex
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.$controller) return;
      var presentationChildren = this.$controller.querySelector('.ironpt__presentation .ironpt__slides').children;
      var slides = _fp2.default.filter(function (el) {
        return el.className === 'ironpt__slide';
      })(presentationChildren);
      this.setState({ slideLength: slides.length });

      // Touch support
      this.hammer = new _hammerjs2.default(this.$controller, {});
      this.hammer.get('swipe').set({ direction: _hammerjs2.default.DIRECTION_ALL });
      this.hammer.on('swipeleft', this.onNextSlide);
      this.hammer.on('swiperight', this.onPrevSlide);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (!this.$controller) return;
      this.hammer.off('swipeleft', this.onNextSlide);
      this.hammer.off('swiperight', this.onPrevSlide);
    }
  }, {
    key: 'selectSlide',
    value: function selectSlide(slideIndex) {
      var slideLength = this.state.slideLength;

      (0, _assert2.default)(_fp2.default.isInteger(slideIndex));
      (0, _assert2.default)(slideIndex >= 0 || slideIndex < slideLength, 'slide out of range (should 0 <= slide < ' + slideLength + ')');
      this.setState({ slideIndex: slideIndex });
    }
  }, {
    key: 'onClick',
    value: function onClick(e) {
      this.$input.focus();
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      switch (e.key) {
        case 'ArrowLeft':
          this.onPrevSlide();
          break;
        case 'ArrowRight':
          this.onNextSlide();
          break;
      }
    }
  }, {
    key: 'onNextSlide',
    value: function onNextSlide() {
      var _state = this.state,
          slideIndex = _state.slideIndex,
          slideLength = _state.slideLength;

      var nextSlide = slideIndex + 1;
      if (nextSlide < slideLength) {
        this.selectSlide(nextSlide);
      }
    }
  }, {
    key: 'onPrevSlide',
    value: function onPrevSlide() {
      var slideIndex = this.state.slideIndex;

      var prevSlide = slideIndex - 1;
      if (prevSlide >= 0) {
        this.selectSlide(prevSlide);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          defaultSlideIndex = _props.defaultSlideIndex,
          props = _objectWithoutProperties(_props, ['children', 'defaultSlideIndex']);

      return _react2.default.createElement(
        'div',
        _extends({
          className: 'ironpt__controller',
          onClick: this.onClick,
          onKeyDown: this.onKeyDown,
          ref: function ref(c) {
            _this2.$controller = c;
          }
        }, props),
        children,
        _react2.default.createElement('input', {
          className: 'ironpt__input-for-keydown',
          type: 'text',
          ref: function ref(c) {
            _this2.$input = c;
          },
          style: {
            width: 0,
            height: 0,
            outline: 'none',
            border: 'none',
            margin: 0,
            padding: 0,
            boxShadow: 'none'
          }
        })
      );
    }
  }]);

  return Controller;
}(_react.Component);

Controller.propTypes = {
  defaultSlideIndex: _react2.default.PropTypes.number,
  defaultStyle: _react2.default.PropTypes.string
};

Controller.childContextTypes = {
  slideIndex: _react2.default.PropTypes.number.isRequired
};

exports.default = Controller;


/*****************
 ** WEBPACK FOOTER
 ** ../lib/Controller.js
 ** module id = 126
 ** module chunks = 0
 **/